export interface Migration {
  id: MigrationType;
  params?: MigrationParams;
}

export enum MigrationType {
  'count-exam-user-rating' = 'count-exam-user-rating',
  'clear-exam-user-rating' = 'clear-exam-user-rating',
  'update-contest-end-date' = 'update-contest-end-date',
  'increment-school-grade' = 'increment-school-grade',
}

export type MigrationParams = Record<string, string>;
